// local-storage.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private baseStorageKey = 'sk_ecomm'; // Base key
  private storageKey = this.baseStorageKey;

  constructor() { }

  
  // Set a specific item by key
  setItem(key: string, value: any): void {
    const appData = this.loadData();
    appData[key] = value; // Set or update the key with the new value
    localStorage.setItem(this.storageKey, JSON.stringify(appData));
  }

  // Get a specific item by key
  getItem(key: string): any {
    const appData = this.loadData();
    try {
      const parsed = JSON.parse(appData[key]);
      return parsed;
    } catch {
      return appData[key]; // fallback
    }
  }


  // Remove a specific item by key
  removeItem(key: string): void {
    const appData = this.loadData();
    if (appData.hasOwnProperty(key)) {
      delete appData[key]; // Remove the key from the app data
      localStorage.setItem(this.storageKey, JSON.stringify(appData)); // Update the storage
    }
  }

  // Clear all app-specific data from localStorage
  clearData(): void {
    localStorage.removeItem(this.storageKey);
  }

  // Load the entire app data object from localStorage
  private loadData(): any {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : {}; // If there's no data, return an empty object
  }
}
